module.exports = __webpack_public_path__ + "media/assets/images/flags/ma-6dbab401560b047f1bcad87d2d5232fc.svg";